import React from "react";

import {
  useDeleteCustomerMutation,
  useDeleteSegmentCustomerBySegmentIdMutation,
} from "@tiny/api";
import { DeleteSubscribersDialogProps } from "./DeleteSubscribersDialog";

export function useDeleteSubscribersDialog(
  props: DeleteSubscribersDialogProps
) {
  const { onSuccess, customers, segmentId } = props;

  const {
    mutateAsync: deleteSegmentCustomerMutateAsync,
    isLoading: isDeleteSegmentCustomerLoading,
  } = useDeleteSegmentCustomerBySegmentIdMutation();

  const {
    mutateAsync: deleteCustomerMutateAsync,
    isLoading: isDeleteCustomerLoading,
  } = useDeleteCustomerMutation();

  const deleteCustomers = React.useCallback(async () => {
    const ids = customers.map(({ id }) => id!);
    if (segmentId) {
      await deleteSegmentCustomerMutateAsync({
        segmentId,
        data: { ids },
      });
    } else {
      await deleteCustomerMutateAsync({
        data: { ids },
      });
    }
    onSuccess();
  }, [
    customers,
    deleteCustomerMutateAsync,
    deleteSegmentCustomerMutateAsync,
    onSuccess,
    segmentId,
  ]);

  const deleting = isDeleteSegmentCustomerLoading || isDeleteCustomerLoading;

  return {
    deleteCustomers,
    deleting,
  };
}
